import React, { CSSProperties, ReactNode, Ref } from 'react';
import cn from 'classnames';
import { LinkTags } from '../Link';
require("./Card.css");
var styles = {
  "Root": "Card-module-Root_2DS",
  "Link": "Card-module-Link_2IE"
};
export const CardTags = {
  div: 'div',
  article: 'article'
};
/**
 * Компонент-обёртка для карточки товара
 * @interface ICardProps
 * @author m.mayorov
 */
export const Card = ({
  className,
  style,
  innerRef,
  controlRef,
  to,
  rel,
  target,
  ariaLabelledBy,
  children,
  tag = CardTags.div,
  linkComponent = LinkTags.a
}) => {
  const RootTag = tag;
  const LinkTag = linkComponent;
  const linkHrefProp = LinkTag === 'a' ? 'href' : 'to';
  return /*#__PURE__*/React.createElement(RootTag, {
    className: cn(styles.Root, className),
    style: style,
    ref: innerRef
  }, to && /*#__PURE__*/React.createElement(LinkTag, {
    ref: controlRef,
    [linkHrefProp]: to,
    rel: rel,
    target: target,
    "aria-labelledby": ariaLabelledBy,
    className: styles.Link
  }), children);
};
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}